import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { AuthenticationError } from '../../../../api/requests/tuitionProcess';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { useStudentCurrentAccountLoader } from '../../components/StudentCurrentAccountLoader';
import { getPaymentHistory } from '../api';
import { PaymentHistoryResponse } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  PaymentHistoryResponse,
  AuthenticationError | AxiosResultDefaultError
>();

export function usePaymentHistorytLoader() {
  return useFetch();
}

export const paymentHistorytLoaderConsumer = FetchConsumer;

export default function PaymentHistorytLoader({ children }: BaseLoaderProps) {
  const { data } = useStudentCurrentAccountLoader();
  const request = useCallback(async () => {
    return getPaymentHistory(data.studentId);
  }, [data.studentId]);
  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately={true}
    >
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading insideCard />;
          } else if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
              />
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
